// No noopener/noreferrer here: those force each call into an isolated
// browsing context, which stops the "share-x" name below from being reused —
// every click would open a brand new window instead of refocusing the old one.
const SHARE_POPUP_FEATURES = "width=550,height=420";

export const openXShareIntent = (
	text: string,
	broadcastId?: string,
	hashtags?: string[],
): void => {
	const withHashtags =
		hashtags && hashtags.length > 0
			? `${text}\n\n${hashtags.map((tag) => `#${tag}`).join(" ")}`
			: text;

	const viewerLink = broadcastId
		? `${window.location.origin}/broadcast/${broadcastId}`
		: undefined;
	const fullText = viewerLink
		? `${withHashtags}\n\nFollow here: ${viewerLink}`
		: withHashtags;

	const url = `https://x.com/intent/tweet?text=${encodeURIComponent(fullText)}`;
	const popup = window.open(url, "share-x", SHARE_POPUP_FEATURES);
	popup?.focus();
};
